// extracted by mini-css-extract-plugin
export default {"container":"ChannelSubmit__container___UXITJ"};